export const trustpilotData = {
  trustScore: 4.6,
  trustReviewsTotal: 42334,
  trustCountry: 'US',
}
